
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.754 2.579a1.067 1.067 0 00-1.508 0l-4 4a1.067 1.067 0 001.508 1.509l2.18-2.18v6.759a1.067 1.067 0 102.133 0V5.908l2.179 2.18a1.067 1.067 0 001.508-1.509l-4-4zM3.353 7.173a.664.664 0 01.176-.311l4-4a.667.667 0 01.942 0l4 4-4-4a.667.667 0 00-.942 0l-4 4a.664.664 0 00-.176.31zm5.314-2.23v7.724-7.724z","fill":"#EDAF0F"}})])
          )
        }
      }
    